export const gradeList = ['beginner', 'intermediate', 'advanced', 'special_long_jump', 'special_high_jump'];